// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2MtXc","insightsList":"newBusinessInsightsMenu_insightsList__MzwLx","active":"newBusinessInsightsMenu_active__1G32K"};